<script lang="ts">
import { onLaunch, onShow, onHide, onLoad, onReady } from '@dcloudio/uni-app'
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'
import { beforEach } from '@/router/index'
import socket from '@/common/socket'
// import mqtt from 'mqtt'




// const globalStore = null
// const mqttClient = ref<mqtt.MqttClient | null>(null)
// const initMqtt = () => {
//   const mqttUrl = import.meta.env.VITE_SKELETON_ALERT_MQTT_URL
//   const alertTopic = import.meta.env.VITE_SKELETON_ALERT_MQTT_TOPIC
//   // 连接MQTT服务器
//   const mqttConfig = {
//     keepalive: 30, // 客户端心跳时间
//     clean: true, // 是否以清除会话的方式建立连接
//     connectTimeout: 30000, // 超时时间
//     // reconnectPeriod: 0,
//     clientId: `mqttjs_${Math.random().toString(16)}`,
//     username: import.meta.env.VITE_SKELETON_ALERT_MQTT_USERNAME,
//     password: import.meta.env.VITE_SKELETON_ALERT_MQTT_PASSWORD,
//     // defaultProtocol: 'ws',
//     rejectUnauthorized: false, // 如果是自签证书，一定要加
//   }
//   // console.log('mqttConfig', mqttConfig)
//   mqttClient.value = mqtt.connect(mqttUrl, mqttConfig)

//   mqttClient.value.subscribe(alertTopic, (err) => {
//     if (!err) {
//       console.log('成功订阅主题', alertTopic)
//     }
//   })

//   mqttClient.value.on('message', (topic, message) => {
//     const newMessage = {
//       id: Date.now(),
//       title: '跌倒告警，请及时处理',
//       time: new Date().toISOString().slice(0, 16).replace('T', ' '),
//       isUrgent: true,
//       isUnread: true,
//     }

//     // 添加音频播放
//     // 只有允许后才播放音频
//     if (globalStore?.canPlayAudio) {
//       const innerAudioContext = uni.createInnerAudioContext()
//       innerAudioContext.src = 'https://minio.xiweike.cn/yuxi-iac/app/voice/alert.mp3' // 注意路径
//       innerAudioContext.play()
//       uni.showToast({
//         title: '发生跌倒事件，请及时处理！',
//         icon: 'success',
//         duration: 5000,
//       })
//     }
//     // 添加确认对话框
//     // uni.showToast({
//     //   title: '发生跌倒事件，请及时处理',
//     //   icon: 'success',
//     //   duration: 3000,
//     // })
//   })

//   mqttClient.value.on('connect', (connack) => {
//     console.log('mqtt连接成功:', connack)
//   })

//   mqttClient.value.on('close', () => {
//     console.log('mqtt关闭连接')
//   })

//   mqttClient.value.on('reconnect', () => {
//     console.log('mqtt正在重连')
//   })

//   mqttClient.value.on('error', (error) => {
//     console.log('mqtt连接失败:', error)
//   })
// }

export default {
  onLaunch: function (options) {
    console.log('App Launch')
    console.log('应用启动路径：', options.path)





    // 初始化MQTT连接
    // initMqtt()
  },
  onShow: function (options) {
    console.log('App Show')
    console.log('应用启动路径：', options.path)
    // 首次进入页面时路由拦截
    setTimeout(() => {
      const currentPage = options.path
      beforEach({ path: '/' }, { path: currentPage, fullPath: currentPage }, (data) => {
        if (data?.path) {
          uni.redirectTo({ url: data.path })
        }
      })
    }, 100)
    this.onSocketOpen()
  },
  onHide: function () {
    console.log('App Hide')
  },
  // 全局变量
  globalData: {
    isLocalConfig: true,
    systemInfo:
      uni.getSystemInfoSync && typeof uni.getSystemInfoSync === 'function'
        ? uni.getSystemInfoSync()
        : {},
    // 导航的高度
    navHeight: 44,
  },
  methods: {
    onSocketOpen() {
      console.log('启动webSocket')
      socket.init('websocket')
    },
    onSocketReceive() {
      socket.acceptMessage = function (res) {
        console.log(666666, res)
        if (res.noticeType === 'system') {
          // paging.value && paging.value.reload()
          uni.showToast({
            icon: 'none',
            title: '您收到新的消息请及时查看!',
          })
          uni.setTabBarBadge({
            index: 0,
            text: '1',
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
:root,
page {
  font-family:
    Helvetica Neue,
    Helvetica,
    sans-serif;
  font-size: 14px;
  color: #333333;
}
uni-page-body {
  height: 100%;
  & > uni-view {
    height: 100%;
  }
}
.shadow-warp {
  position: relative;
  box-shadow: 0 0 5px rgba(168, 92, 92, 0.1);
}
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
/*每个页面公共css */
radio {
  transform: scale(0.7);
}

.full-page {
  /* 让页面内容高度=视口高度-状态栏安全区高度（iOS/APP/H5 兼容） */
  min-height: 100vh; /* fallback */
  /* 旧版 iOS WebKit */
  min-height: calc(100vh - constant(safe-area-inset-top));
  /* 标准 iOS 安全区 */
  min-height: calc(100vh - env(safe-area-inset-top));

  min-height: calc(100vh - var(--app-safe-top, 0px) - 88rpx);

  overflow: auto;
  -webkit-overflow-scrolling: touch; /* iOS 平滑滚动 */
}

.max-full-page {
  /* 让页面内容高度=视口高度-状态栏安全区高度（iOS/APP/H5 兼容） */
  height: 100vh; /* fallback */
  /* 旧版 iOS WebKit */
  height: calc(100vh - constant(safe-area-inset-top));
  /* 标准 iOS 安全区 */
  height: calc(100vh - env(safe-area-inset-top));

  height: calc(100vh - var(--app-safe-top, 0px) - 88rpx);

}
/* 自定义导航页面：给内容整体增加状态栏安全距离 */
.with-statusbar {
  padding-top: var(--app-safe-top, 0px);
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}
</style>
